import PropTypes from "prop-types";
import * as React from "react";
import ShopsSlider from "../../components/Home/Section/ShopsSlider";
import { useMatchesSmDown } from "../../hooks";
import { Box, Typography } from "../../themeV2";
import css from "./Recommendations.module.css";

function RecommendedRow({ title, influencers, recommendedShops, isMobile }) {
  return (
    <section className={css.row}>
      <Typography variant="title-lg" as="h2">
        {title}
      </Typography>
      <ShopsSlider
        influencers={influencers}
        isMobile={isMobile}
        count={true}
        recommendedShops={recommendedShops}
      />
    </section>
  );
}

RecommendedRow.propTypes = {
  title: PropTypes.string.isRequired,
  influencers: PropTypes.array.isRequired,
  recommendedShops: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default function Recommendations({ recommendedShops, youMightLike }) {
  const isMobile = useMatchesSmDown();

  return (
    <Box direction="column" gap={6} className={css.root}>
      {youMightLike?.length > 0 && (
        <RecommendedRow
          title="You might like..."
          influencers={youMightLike}
          isMobile={isMobile}
        />
      )}

      {recommendedShops?.length > 0 && (
        <RecommendedRow
          title="Recommended shops"
          influencers={recommendedShops}
          isMobile={isMobile}
          recommendedShops={true}
        />
      )}
    </Box>
  );
}

Recommendations.propTypes = {
  recommendedShops: PropTypes.array,
  youMightLike: PropTypes.array,
};
